import { useToast } from "@/components/ui/use-toast";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { ContestAgreementsService } from "@/services/contestAgreements";
import { MailIcon } from "lucide-react";
import { memo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { usePayrollParams } from "../hooks/usePayrollParams";
import { PayrollConfirmButton } from "./PayrollConfirmButton";

export const PayrollSendContestConfirmationButton = memo(() => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { payrollId } = usePayrollParams();
  const { toast } = useToast();

  const mutation = useMutationWithErrorHandling({
    errorTitle: t("payrolls.errors.sendContestConfirmation"),
    mutationFn: ContestAgreementsService.sendAll,
    onSuccess: () => {
      toast({
        title: t("payrolls.success.sendContestConfirmation"),
      });
    },
  });

  const onConfirm = useCallback(() => {
    mutation.mutateAsync(payrollId);
  }, [mutation]);

  return (
    <PayrollConfirmButton
      icon={MailIcon}
      translationKey="payrolls.sendContestConfirmation"
      open={open || mutation.isPending}
      onOpenChange={setOpen}
      onConfirm={onConfirm}
      isPending={mutation.isPending}
    />
  );
});
